import * as React from 'react';
import { Form, Input, EditModes } from 'library';
import { IFormData, IFormState, SystemFormDetail } from 'library/form/SystemFormDetail';

interface IDataModel extends IFormData {
    PrimaryKeyEncrypted?: string,
    QuestionNumber?: number,
    QuestionText?: string,
    ScoreCardGroupId?: number,
    NegativeScoreText?: string,
    NormalScoreText?: string,
    PositiveScoreText?: string,
    RowVersion?: string
}

export default class ProjectScoreCardQuestionForm extends SystemFormDetail<IDataModel>{
    constructor(props: any) {       
        super(props);
    }

    initial = (): IFormState<IDataModel> => {
        return {
            formData: {                
                PrimaryKeyEncrypted: (this.props.data && this.props.data.PrimaryKeyEncrypted) ? this.props.data.PrimaryKeyEncrypted : undefined,
                ScoreCardGroupId: (this.props.data && this.props.data) ? this.props.data : undefined 
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {           
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    QuestionNumber: data.QuestionNumber,
                    QuestionText: data.QuestionText,
                    ScoreCardGroupId: data.ScoreCardGroupId,
                    NegativeScoreText: data.NegativeScoreText,
                    NormalScoreText: data.NormalScoreText,
                    PositiveScoreText: data.PositiveScoreText,
                    RowVersion: data.RowVersion,
                }
            })
        }
    }

    render() {
        return (<>
            <Form
                label="Score Card Question"
                url={'ScoreCardVersionQuestion'}
                onLoad={this.load}
                showReview={false}
                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                securityObject="Top.ScoreCardQuestions"
                schema="Top" table="ScoreCardQuestions"
                onInitialize={this.initialize}
                onClear={this.initialize}
                onValidate={this.validate}
                onPrepare={this.prepare}
                onRecordUpdated={this.onRecordUpdated}>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="QuestionNumber"
                        name="QuestionNumber"
                        label='Question Number'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange} 
                        validator={this.validator}
                        value={this.state.formData.QuestionNumber} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="QuestionText"
                        name="QuestionText"
                        label='Question Text'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        value={this.state.formData.QuestionText}
                        validator={this.validator} />
                </div>  

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="NegativeScoreText"
                        name="NegativeScoreText"
                        label='Negative Score Text'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        value={this.state.formData.NegativeScoreText}
                        validator={this.validator} />
                </div> 

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="NormalScoreText"
                        name="NormalScoreText"
                        label='Normal Score Text'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        value={this.state.formData.NormalScoreText}
                        validator={this.validator} />
                </div> 

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="PositiveScoreText"
                        name="PositiveScoreText"
                        label='Positive Score Text'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        value={this.state.formData.PositiveScoreText}
                        validator={this.validator} />
                </div> 
            </Form>        
        </>)
    }
};